import { LoaderFunction, redirect } from "react-router-dom";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";

/**
 * Redirects guests to signup. Use on routes that require authentication
 * (detail pages, finance, settings, etc.) without a separate layout shell.
 */
export const requireAuthenticatedLoader: LoaderFunction = async () => {
  const user = await getReadyAuthUser();
  if (!user) {
    return redirect("/signup");
  }
  return null;
};
